import { useContext } from 'react';
import { TimeUnit } from 'gen/ApiClient';
import { RecordContext } from '../records/RecordContext';
import { renderTimeUnitValue } from './renderTimeUnitValue';

export function useRenderTimeUnit(): (value: number, unit: TimeUnit) => string {
	const { timeUnitRecord } = useContext(RecordContext);
	return (value: number, unit: TimeUnit) => renderTimeUnitValue(value, unit, timeUnitRecord);
}
